
import React, { useEffect, useState, useRef } from "react";
import { Box, Button, LinearProgress, Typography, styled } from '@mui/material';
import { XrGoodPrivacy } from "xrgoods-dev";
import { XrGoodDeviceError } from "xrgoods-dev";

import PermissionComp from "./PermissionComp";

import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import FooterComp from "./FooterComp";
import {triggerAnalytics} from "../modules/GoogleDataLayer";

function LandingComp({ loading, startAR, arStarted, setARstarted }) {


    console.log({ loading })
    const [permissions, setPermission] = useState(false)
    const [privacyMode, setPrivacyMode] = useState(false);
    const [isMobile, setIsMobile] = useState(false)


    const requestCamera = () => {
        return new Promise((resolve, reject) => {
            try {
                navigator.mediaDevices
                    .getUserMedia({
                        video: true,
                    })
                    .then((stream) => {
                        stream.getTracks().forEach((track) => track.stop());
                        resolve(true);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            } catch {
                reject();
            }
        });
    };

    const requestMotion = () => {
        return new Promise((resolve, reject) => {
            try {
                if (window.DeviceOrientationEvent) {
                    if (window.DeviceOrientationEvent.requestPermission) {
                        window.DeviceOrientationEvent.requestPermission().then(
                            (granted) => {
                                if (granted) {
                                    window.addEventListener("deviceorientation", () => {
                                        resolve(true);
                                    });
                                } else {
                                    resolve(false);
                                }
                            }
                        );
                    } else {
                        let motionConfirmed = false;
                        window.addEventListener("deviceorientation", (e) => {
                            if (e && !motionConfirmed) {
                                motionConfirmed = true;
                            }
                        });
                        setTimeout(() => {
                            if (motionConfirmed) {
                                resolve(motionConfirmed);
                            } else {
                                resolve(false);
                            }
                        }, 500);
                    }
                } else {
                    resolve(false);
                }
            } catch {
                reject();
            }
        });
    };

    const requestPermission = () => {
        Promise.all([
            requestMotion(),
            requestCamera()
        ])
            .then((res) => {
                if (res[0] && res[1]) {
                    startAR()
                } else {
                    const data = {
                        motion: res[0],
                    };
                    setPermission(true)
                    console.log(data)

                }
            })
            .catch((error) => {
                const data = {
                    camera: false,
                    motion: false,
                };
                // console.log(data)
                setPermission(true)
                throw error;
            });
    };

    const startARHandler = () => {
        const isMobile = checkMobile()
        console.log({ isMobile })
        if (isMobile) {
            setARstarted(true)
            requestPermission()
            // startAR()
        } else {
            setIsMobile(true)
        }

        // setARstarted(true)
        // // requestPermission()
        // startAR()

    }

    const checkMobile = () => {

        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;

    }

    return (
        <>
            {isMobile && <XrGoodDeviceError onClose={() => { setIsMobile(false) }} />}
            {privacyMode && (
                <XrGoodPrivacy
                    logo="./assets/images/3mera-icon-square.svg"
                    company="3Mera"
                    content="By proceeding, you agree to 3Mera Terms of Service and acknowledge the Privacy Policy."
                    onClose={() => {
                        setPrivacyMode(null);
                    }}
                />
            )}
            {permissions && <PermissionComp setPrivacyMode={setPrivacyMode} />}
            {/* <PermissionComp /> */}
            <Box sx={{
                position: 'absolute',
                top: '0',
                left: "0",
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: "40px",
                transition: 'opacity 1s',
                opacity: '1',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                // backgroundColor:"#de2d21",
                fontWeight: 600,
                overflow: "hidden",
            }}>

                <Box
                    component='video'
                    src="./assets/videos/bg.mp4"
                    playsInline
                    muted
                    autoPlay
                    loop
                    sx={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: '100vw',
                        height: "100vh",
                        objectFit: "cover",
                        zIndex: "-100"
                    }}
                >
                </Box>

                < Box
                    sx={{
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'absolute',
                        height: '120%',
                        width: '110%',
                        filter: "blur(4px)",
                    }}
                >

                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        top: "0",
                        left: "0",
                        width: '100%',
                        height: "100%",
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                        color: 'white'
                    }}
                >

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-evenly',
                            color: 'white',
                            gap: "10px"
                        }}
                    >
                        {arStarted ? <Box
                            sx={{
                                height: "40px",
                                display: "flex",
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <LinearProgress
                                variant="determinate"
                                value={loading}
                                sx={{
                                    width: "100px"
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: "0.7rem"
                                }}
                            >{loading}%</Typography>
                        </Box> :
                            <Box

                                sx={{
                                    maxWidth: "350px",
                                    display: "flex",
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: "10px",
                                    position: "relative"
                                }}
                            >


                                <Box
                                    component='img'
                                    src="./assets/images/dragon.png"
                                    sx={{
                                        width: "80%",
                                        position: 'absolute',
                                        top: "10px",
                                        zIndex: "-1"

                                    }}
                                />
                                <Box
                                    component="img"
                                    src={"./assets/images/logo-green.svg"}
                                    sx={{
                                        width: "120px",
                                    }}
                                />

                                {/* <Typography
                                    sx={{
                                        fontFamily: "Times New Roman",
                                        fontSize: "4rem",
                                        textAlign: "center",
                                        color: "#ECAD0C",
                                        fontWeight: "700",
                                        textTransform: "uppercase",
                                        lineHeight: "70px",
                                        TextShadow: "1px 1px 2px black"

                                    }}
                                >
                                    eastvale lantern festival

                                </Typography> */}

                                <Box
                                    component="img"
                                    src={"./assets/images/title.svg"}
                                    sx={{
                                        width: "90%",
                                    }}
                                />

                                <Box

                                    sx={{
                                        height: "80px"
                                    }}
                                />

                                <PrimaryButton
                                    onClick={() => {
                                        triggerAnalytics("start_ar")
                                        startARHandler()
                                    }}
                                >
                                    Launch experience
                                </PrimaryButton>
                                <SecondaryButton
                                    onClick={() => {
                                        triggerAnalytics("whats_new_eastvale")
                                        window.open("https://www.eastvaleca.gov/i-want-to/sign-up-for-enotification", '_blank')

                                    }}
                                >What’s new eastvale</SecondaryButton>
                                <FooterComp setPrivacyMode={setPrivacyMode} />
                                {/* <Box
                                    component='img'
                                    src={"./assets/images/3mera-logo.svg"}
                                    sx={{
                                        height: "2vh"
                                    }}
                                >
                                </Box> */}
                            </Box>


                        }
                    </Box>

                </Box>

            </Box >
        </>
    );
}

export default LandingComp;


